// Proves the Stimulus application is wired into the pack and connecting to the
// DOM. The system spec asserts on what this writes; delete it once real
// controllers cover that ground.
import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.element.dataset.harnessConnected = 'true';
  }
}
